var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('p',{staticClass:"title"},[_vm._v("区县排行")]),_c('div',{staticClass:"rank-contain"},[_c('areaCountryEarChat',{attrs:{"rankList":_vm.countyCompareData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }